import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import TopBar from './TopBar';

import * as filtersActions from '../../../actions/filters-actions';
import * as reportBuilderActions from '../../../actions/report-builder-actions';
import * as reportBuilderSelectors from '../../../reducers/report-builder-reducer';
import * as filtersSelectors from '../../../reducers/filters-reducer';
import {
  selectUserId,
  selectAllowedPages
} from '../../../reducers/user-reducer';

const showContentTypes = pages =>
  pages && pages.includes('/shows') && pages.includes('/movies');
const showNetworks = pages => pages && pages.includes('/shows');
const showStudios = pages => pages && pages.includes('/movies');

const mapStateToProps = state => {
  const allowedPages = selectAllowedPages(state);
  return {
    filters: state.filters,
    filterValues: filtersSelectors.selectFilterValues(state),
    loading: reportBuilderSelectors.selectLoading(state),
    name: reportBuilderSelectors.selectName(state),
    reportUserId: reportBuilderSelectors.selectUserId(state),
    userId: selectUserId(state),
    showContentTypes: showContentTypes(allowedPages),
    showNetworks: showNetworks(allowedPages),
    showStudios: showStudios(allowedPages)
  };
};

const mapDispatchToProps = dispatch => ({
  filtersActions: bindActionCreators(filtersActions, dispatch),
  reportBuilderActions: bindActionCreators(reportBuilderActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(TopBar);
